export type TimeoutUnit = 'minutes' | 'hours';

export function formatDurationMilliseconds(milliseconds: number | null | undefined): string {
  if (!Number.isFinite(milliseconds) || !milliseconds || milliseconds < 0) return '—';

  const totalSeconds = Math.floor(milliseconds / 1_000);
  const hours = Math.floor(totalSeconds / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);
  const seconds = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function formatRunDuration(startedAtUtc?: string | null, completedAtUtc?: string | null,
  now = Date.now()): string {
  if (!startedAtUtc) return '—';
  const started = Date.parse(startedAtUtc);
  const ended = completedAtUtc ? Date.parse(completedAtUtc) : now;
  if (!Number.isFinite(started) || !Number.isFinite(ended)) return '—';
  return formatDurationMilliseconds(Math.max(0, ended - started));
}

export function timeoutEditorValue(milliseconds: number): { value: number; unit: TimeoutUnit } {
  if (milliseconds > 0 && milliseconds % 3_600_000 === 0) {
    return { value: milliseconds / 3_600_000, unit: 'hours' };
  }
  return { value: Math.max(1, Math.round(milliseconds / 60_000)), unit: 'minutes' };
}
